import { render, staticRenderFns } from "./UpdateProviderBank.vue?vue&type=template&id=0c3bef1e&"
import script from "./UpdateProviderBank.vue?vue&type=script&lang=js&"
export * from "./UpdateProviderBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports